import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as EditIcon } from './edit.svg';

export const Edit = IconHOC(EditIcon);
